import {
  Flex,
  HStack,
  Stack,
  Image,
  Box,
  Text,
  Avatar,
  StackDivider,
  Select,
  Wrap,
  WrapItem,
  Badge,
} from "@chakra-ui/react";
import React from "react";
import { BiEdit, BiTime } from "react-icons/bi";
import { ImProfile } from "react-icons/im";
import { BsFillCheckCircleFill, BsFillStarFill } from "react-icons/bs";

export default function ProfileDetails() {
  return (
    <Flex flexDir={{ base: "column", lg: "row" }}>
      <Stack
        bg="#eee"
        p={5}
        w={{ lg: "25%" }}
        gap={5}
        divider={<StackDivider borderColor="#c5c5c5" />}
      >
        <Box>
          <HStack justifyContent={"space-between"}>
            <Image src="/images/gigImage/verified-90px.png" w="88px" />
            <HStack
              alignItems="center"
              gap={1}
              color="brand.500"
              cursor="pointer"
            >
              <Text>Edit</Text>
              <BiEdit />
            </HStack>
          </HStack>
          <Stack alignItems="center" gap={2}>
            <Avatar
              src="/images/freelancer/profiles/1.png"
              size="xl"
              alignItems={"start"}
              borderRadius={"full"}
              w="fit-content"
              border={0}
            >
              <Box
                as="span"
                pos="relative"
                left="-22px"
                top="6px"
                p="8px"
                fontSize="xs"
                fontWeight="bold"
                lineHeight="none"
                color="green.100"
                bg="#00D900"
                rounded="full"
              />
            </Avatar>
            <HStack color="#0079BC">
              <Text fontWeight="bold">Logo Master</Text>
              <BsFillCheckCircleFill />
            </HStack>
            <HStack>
              <Box color="#FFBE5B">
                <BsFillStarFill />
              </Box>
              <Text fontWeight="bold">4.8</Text>
              <Text color="gray.500" fontWeight="bold">
                (2k)
              </Text>
            </HStack>
          </Stack>
        </Box>
        <HStack
          justifyContent="space-between"
          fontSize={{ lg: "20px" }}
          color="#008DDBAB"
          align="center"
          fontWeight="semibold"
        >
          <Text textDecor={"underline"} cursor="pointer">
            Available Bid Token:
          </Text>
          <Text>60</Text>
        </HStack>
      </Stack>
      <Stack
        w={{ lg: "75%" }}
        px={10}
        py={6}
        bg="#F7F7F7"
        divider={<StackDivider color="#c5c5c5" />}
        alignItems={"start"}
      >
        <HStack
          justifyContent="space-between"
          flexDir={{ base: "column-reverse", lg: "row" }}
          w={{base:"full",lg:""}}
          alignItems="start"
          gap={1}
        >
          <HStack divider={<StackDivider color="#c5c5c5" />} gap={5} align="start" flexDir={{base:"column",sm:"row"}}  w="full" >
            <Box>
              <Box fontWeight={"medium"} fontSize="14px">
                <Text mb={1}>From</Text>
                <HStack>
                  <Image src="/images/gigImage/us-flag.png" w="26px" />
                  <Text color="#909090">United States</Text>
                </HStack>
              </Box>
              <Box fontWeight={"medium"} fontSize="14px" display={{base:"none",lg:"none"}} pt={4}>
                <Text mb={1}>Avg. Response Time</Text>
                <HStack>
                  <Box color="brand.400">
                    <BiTime size="26px" />
                  </Box>
                  <Text color="#909090">1 Hour</Text>
                </HStack>
              </Box>
            </Box>
            <Box fontWeight={"medium"} fontSize="14px">
              <Text mb={1}>Member Since</Text>
              <HStack>
                <Box color="brand.400">
                  <ImProfile size="26px" />
                </Box>
                <Text color="#909090">Feb 2022</Text>
              </HStack>
            </Box>
            <Box fontWeight={"medium"} fontSize="14px" display={{base:"block",lg:"block"}}>
              <Text mb={1}>Avg. Response Time</Text>
              <HStack>
                <Box color="brand.400">
                  <BiTime size="26px" />
                </Box>
                <Text color="#909090">1 Hour</Text>
              </HStack>
            </Box>
          </HStack>
          <HStack gap={2} flexDir={{ base: "column", xl: "row" }} w={{base:"full",lg:"min-content",xl:""}} alignItems={{base:"start",lg:""}} pb={{base:5,lg:0}} >
            <Text
              fontWeight={"semibold"}
              minW="max-content"
              fontSize={{ base: "16px", lg: "18px" }}
              cursor="pointer"
            >
              Active Orders -
              <Box as="span" color="#c5c5c5">
                0 ($0)
              </Box>
            </Text>
            <Select placeholder="Active orders (0)" bg="white" w={{base:"full",lg:""}}minW="160px" ml={0}>
              <option>Order</option>
            </Select>
          </HStack>
        </HStack>
        <HStack alignItems="start" gap={{lg:10}} flexDir={{ base: "column-reverse", lg: "row" }}>
          <Stack divider={<StackDivider />} gap={{base:4,lg:0}}>
            <Text fontSize={{ base: "14px", lg: "19px" }} color="#8f8f8f">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
              rhoncus turpis nec neque sollicitudin, a tincidunt lorem
              ultricies. Morbi eu commodo nisi. Praesent tempus auctor lacinia,
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
              rhoncus turpis nec neque sollicitudin, a tincidunt lorem
              ultricies. Morbi eu commodo nisi. Praesent tempus auctor lacinia..
              Aliquam rhoncus turpis nec neque sollicitudin,
            </Text>

            <HStack my={4} gap={5} flexDir={{ base: "column", lg: "row" }} alignItems="start" >
              <Box w={{base:"full",lg:"fit-content"}}>
                <HStack gap={{lg:10}} fontWeight={"medium"} mb={3} justifyContent={{base:"space-between",lg:"start"}}>
                  <Text color="black" fontSize={{ base: "16px", lg: "18px" }}>
                    Languages
                  </Text>
                  <HStack
                    alignItems="center"
                    gap={1}
                    color="brand.500"
                    cursor="pointer"
                  >
                    <Text>Edit</Text>
                    <BiEdit />
                  </HStack>
                </HStack>
                <Stack  justifyContent={{base:"space-between",lg:"start"}} alignItems={"start"} flexWrap={{base:"wrap"}}>
                <Text
                  fontWeight={"semibold"}
                  minW="max-content"
                  fontSize={{ base: "16px", lg: "18px" }}
                  color="brand.500"
                >
                  English -
                  <Box as="span" color="#c5c5c5" ml={1}>
                    Fluent
                  </Box>
                </Text>
                <Text
                  fontWeight={"semibold"}
                  minW="max-content"
                  fontSize={{ base: "16px", lg: "18px" }}
                  color="brand.500"
                >
                  German -
                  <Box as="span" color="#c5c5c5" ml={1}>
                    Fluent
                  </Box>
                </Text>
                </Stack>
              </Box>
              <Box w={{base:"full",lg:"fit-content"}}>
                <HStack gap={{lg:10}} fontWeight={"medium"} mb={3} justifyContent={{base:"space-between",lg:"start"}}>
                  <Text color="black" fontSize={{ base: "16px", lg: "18px" }}>
                    Skills
                  </Text>
                  <HStack
                    alignItems="center"
                    gap={1}
                    color="brand.500"
                    cursor="pointer"
                  >
                    <Text>Edit</Text>
                    <BiEdit />
                  </HStack>
                </HStack>
                <Wrap maxW="260px">
                  <WrapItem>
                    <Badge
                      variant="outline"
                      color="#888"
                      borderRadius={10}
                      px={3}
                      py={1}
                    >
                      Logo Design
                    </Badge>
                  </WrapItem>
                  <WrapItem>
                    <Badge
                      variant="outline"
                      color="#888"
                      borderRadius={10}
                      px={3}
                      py={1}
                    >
                      Graphic Design
                    </Badge>
                  </WrapItem>
                  <WrapItem>
                    <Badge
                      variant="outline"
                      color="#888"
                      borderRadius={10}
                      px={3}
                      py={1}
                    >
                      Modern Logo Design
                    </Badge>
                  </WrapItem>
                </Wrap>
              </Box>
            </HStack>
          </Stack>
          <HStack
            alignItems="center"
            gap={1}
            justifyContent={{base:"end",lg:"start"}}
            color="brand.500"
            cursor="pointer"
          >
            <Text>Edit</Text>
            <BiEdit />
          </HStack>
        </HStack>
      </Stack>
    </Flex>
  );
}
